import * as moment from 'moment';
import * as _ from 'lodash';
import React, { FormEvent } from 'react';
import { IRecipientProfilePostTransplantData } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel, Radio, Row } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import styled from 'styled-components';

const BodyWrapper = styled(Panel.Body)`
    .form-group {
        margin-bottom: 10px;
    }
`;

interface IProps {
    data: IRecipientProfilePostTransplantData,
    onChange: (data: IRecipientProfilePostTransplantData) => void
}

const KidneyForLife = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let data = _.cloneDeep(props.data);
        let { name, value } = e.currentTarget;

        if (name == 'kflFollowupOptOut') {
            data.kflFollowupOptOut = parseInt(value) == 1;
        }

        if (name == 'hasDeNovoDSA') {
            if (parseInt(value) == 1) {
                data.hasDeNovoDSA = true;
            }

            if (parseInt(value) == 0) {
                data.hasDeNovoDSA = false;
            }

            if (value == null) {
                data.hasDeNovoDSA = null;
            }
        }

        if (name == 'deNovoDSADate') {
            data.deNovoDSADate = value;
        }

        if (name == 'deNovoDSA') {
            data.deNovoDSA = value;
        }

        if (name == 'deNovoDSAMFI') {
            data.logisticsProvider = value;
        }

        props.onChange(data);
    };

    return (
        <Panel>
            <Panel.Heading>Kidney for Life</Panel.Heading>
            <BodyWrapper>
                <FormGroup>
                    <ControlLabel>Does this patient want to opt-out of the KFL follow up program?</ControlLabel>
                    <div style={{ minHeight: 34 }}>
                        <Radio inline name='kflFollowupOptOut' value={1} checked={props.data.kflFollowupOptOut != null ? props.data.kflFollowupOptOut : false} onChange={handleDataChange}>Yes</Radio>
                        <Radio inline name='kflFollowupOptOut' value={0} checked={props.data.kflFollowupOptOut != null ? !props.data.kflFollowupOptOut : false} onChange={handleDataChange}>No</Radio>
                    </div>
                </FormGroup>
                <Row>
                    <Col xs={12} lg={4}>
                        <FormGroup>
                            <ControlLabel>Did this patient develop a DeNovo DSA?</ControlLabel>
                            <div style={{ minHeight: 34 }}>
                                <Radio id='hasDeNovoDSAYes' name='hasDeNovoDSA' inline value={1} checked={props.data.hasDeNovoDSA == true} onChange={handleDataChange}>Yes</Radio>
                                <Radio id='hasDeNovoDSANo' name='hasDeNovoDSA' inline value={0} checked={props.data.hasDeNovoDSA == false} onChange={handleDataChange}>No</Radio>
                                <Radio id='hasDeNovoDSAUnknown' name='hasDeNovoDSA' inline value={null} checked={props.data.hasDeNovoDSA == null} onChange={handleDataChange}>Unknown</Radio>
                            </div>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={4}>
                        <FormGroup>
                            <ControlLabel>When did this patient develop a DeNovo DSA?</ControlLabel>
                            <MaskedInput
                                name='deNovoDSADate'
                                className='form-control'
                                style={{ width: 300 }}
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                value={props.data.deNovoDSADate != null ? moment(props.data.deNovoDSADate).format('MM/DD/YYYY') : ''}
                                onChange={handleDataChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12} lg={4}>
                        <FormGroup>
                            <ControlLabel>Which Antigen/Allele is this DeNovo DSA?</ControlLabel>
                            <FormControl
                                name='deNovoDSA'
                                style={{ width: 300 }}
                                value={props.data.deNovoDSA}
                                onChange={handleDataChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={6}>
                        <FormGroup>
                            <ControlLabel>What is the MFI of this DeNovo DSA?</ControlLabel>
                            <FormControl
                                name='deNovoDSAMFI'
                                style={{ width: 300 }}
                                value={props.data.deNovoDSAMFI}
                                onChange={handleDataChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </BodyWrapper>
        </Panel>
    );
}

export default KidneyForLife;